var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-text",
        {
          staticClass: "pa-4"
        },
        [
          _c(
            "v-row",
            {
              attrs: {
                align: "center",
                justify: "space-between",
                "no-gutters": ""
              }
            },
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "auto"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-center"
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass: "text-h5 font-weight-medium mr-3 mb-0"
                        },
                        [_vm._v(" " + _vm._s(_vm.title) + " ")]
                      ),
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            small: ""
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.websitesCount) +
                              " " +
                              _vm._s(
                                _vm.websitesCount === 1 ? "website" : "websites"
                              ) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "auto"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-center"
                    },
                    [
                      _c("gg-text-field", {
                        staticClass: "search-field mr-3",
                        attrs: {
                          placeholder: "Quick search",
                          "hide-details": ""
                        },
                        on: {
                          input: _vm.onSearchInput
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "prepend-inner",
                            fn: function fn() {
                              return [_c("v-icon", [_vm._v("mdi-magnify")])]
                            },
                            proxy: true
                          }
                        ]),
                        model: {
                          value: _vm.searchQuery,
                          callback: function callback($$v) {
                            _vm.searchQuery = $$v
                          },
                          expression: "searchQuery"
                        }
                      }),
                      _vm._t("filter"),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-3 text-none",
                          attrs: {
                            text: ""
                          },
                          on: {
                            click: _vm.onCollapseAll
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                left: "",
                                small: ""
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.collapsed
                                    ? "mdi-chevron-down"
                                    : "mdi-chevron-up"
                                )
                              )
                            ]
                          ),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.collapsed ? "Expand All" : "Collapse All"
                              ) +
                              " "
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }